import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _toastrService: ToastrService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          localStorage.clear();
          this._router.navigateByUrl('/login');
        } else if (error.status === 400) {
          this._toastrService.error(this._generateBadRequestMessage(error), 'Er zijn fout(en) opgetreden', { enableHtml: true });
        } else if (error.status >= 500) {
          this._toastrService.error('Er is iets fout gegaan, probeer het later opnieuw.');
        }
        return throwError(error);
      })
    ) as any;
  }

  private _generateBadRequestMessage(err: HttpErrorResponse): string {
    if (err.error.model && err.error.model.length > 0) {
      let message = '';

      err.error.model.forEach(errorEntry => {
        message += `<li>${errorEntry}</li>`;
      });

      return `<ul>${message}</ul>`;
    }

    return '';
  }
}
